import { Component, OnInit, ViewChild } from '@angular/core';
import { InternalHomeService } from '../../internal-home.service';
import { Dbindices } from '../../../../../core/entities/dbindices.model';
import { MatDialog } from '@angular/material/dialog';
import { EditDialogsDbindicesComponent } from './dialogs-dbindices/edit-dialogs-dbindices/edit-dialogs-dbindices.component';
import { ViewDialogsDbindicesComponent } from './dialogs-dbindices/view-dialogs-dbindices/view-dialogs-dbindices.component';
import { DialogsConfirmComponent } from '../../../../../shared/components/dialogs/dialogs-confirm/dialogs-confirm.component';
import { TranslateService } from '@ngx-translate/core';
import { FormCanDeactivate } from '../../../../../core/guards/deactivate/form-can-deactivate';
import { NgForm } from '@angular/forms';
import { Utils } from 'src/app/core/utils/utils';
import { DialogsAlertComponent } from 'src/app/shared/components/dialogs/dialogs-alert/dialogs-alert.component';
import { UNAUTHORIZED, FORBIDDEN } from '../../../../../core/utils/constants';

@Component({
  selector: 'app-dbindices',
  templateUrl: './dbindices.component.html',
  styleUrls: ['./dbindices.component.scss']
})
export class DbindicesComponent extends FormCanDeactivate implements OnInit {

  @ViewChild('f', {static: true})
  form!: NgForm;
  loading: boolean = true;
  dbindice: Dbindices = new Dbindices();

  mensajeError: boolean = false;

  constructor(public internalHomeService: InternalHomeService,
    private dialog: MatDialog,
    private translateService: TranslateService) {
    super();
  }

  ngOnInit() {
    this.mensajeError = false;
    this.getAllDbindices();
    this.internalHomeService.mostrarMenu();
  }

  /**
  * @description
  * Se llama al servicio para traernos todos los datos de la tabla dbindices
  */
  private getAllDbindices(): void {

    this.loading = true;

    if(this.internalHomeService.chivato)
        this.internalHomeService.arrayDbindices = [];

    this.internalHomeService.viewDbmodels.info = true;
    this.internalHomeService.allDbindices().subscribe(res => {
        console.log(res);
        this.loading = false;
    }, error => {
        this.mensajeError = true;
        this.loading = false;
        this.showMsg(error);
        console.log("Error: " + error);
    });
  }

  /**
  * @description
  * Abre el dialog para crear un dbindice
  * @param dbindice Opcional. Dbindice vacio.
  */
  public createDbindice(dbindice?: Dbindices) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = false;
    dbindice = this.dbindice;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbindicesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbindice, titulochange }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.internalHomeService.allDbindices();
      }, 1000);
    });
  }

  /**
  * @description
  * Abre el dialog para modificar un dbindice
  * @param dbindice Opcional. Dbindice a editar.
  */
  public editDbindice(dbindice?: Dbindices) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(EditDialogsDbindicesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbindice, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbindices();
      }, 1000);
    });
  }

  /**
  * @description
  * Elimina un dbindice
  * @param dbindice Dbindice a eliminar
  */
  public removeDbindice(dbindice?: Dbindices) {
    Utils.toggleAllButtonsAndHref(true);
    const dialogRef = this.dialog.open(DialogsConfirmComponent, {
      disableClose: true,
      hasBackdrop: true,
      data: { texto: this.translateService.instant('WARNINGS.dato_dbindices') }
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe(result => {
      Utils.toggleAllButtonsAndHref(false);
      if (result) {
        this.loading = true;
        this.internalHomeService.removeDbindices(dbindice).subscribe(res => {
          console.log(res);
          this.getAllDbindices();
          this.loading = false;
        }, error => {
          this.loading = false;
          console.log("Error: " + error);
        });
      }
    });
  }

  /**
  * @description
  * Abre el dialog para visualizar un dbindice
  * @param dbindice Opcional. Dbindice a ver.
  */
  public viewDbindice(dbindice?: Dbindices) {
    Utils.toggleAllButtonsAndHref(true);
    let titulochange = true;
    let anchodisp: string = "";
    window.screen.width < 500 ? anchodisp = '85%' : anchodisp = "50%";
    const dialogRef = this.dialog.open(ViewDialogsDbindicesComponent, {
      width: anchodisp,
      disableClose: true,
      hasBackdrop: true,
      data: { dbindice, titulochange}
    });
    Utils.accessibilityDialogCdk();
    dialogRef.afterClosed().subscribe((result: boolean) => {
      Utils.toggleAllButtonsAndHref(false);
      if(result)
      setTimeout(() => {
        this.getAllDbindices();
      }, 1000);
    });
  }

  /**
  * Muestra el mensaje de error correspondiente en caso de error
  * @param error Objeto de error.
  */
  private showMsg(error: any) {
    const msg: string = error == null || (error != null && (error.status !== UNAUTHORIZED && error.status !== FORBIDDEN)) ? this.translateService.instant('ACCESO.loginError') : this.translateService.instant('ACCESO.loginError' + error.status);
    this.dialog.open(DialogsAlertComponent, {
      data: { texto: msg }
    });
  }

}
